import { render, staticRenderFns } from "./ConfigPayment.vue?vue&type=template&id=48cd0c90"
import script from "./ConfigPayment.vue?vue&type=script&lang=js"
export * from "./ConfigPayment.vue?vue&type=script&lang=js"
import style0 from "./ConfigPayment.vue?vue&type=style&index=0&id=48cd0c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports